// Modelo del usuario logado
export class User {
    public userName: string;
    public urlLanguage: string;
    public language: string;
    public uid?: string;
    public creationUserType?: number;
    // tslint:disable-next-line:no-empty
    constructor() { }

    UpdateUserContext = (name: string, langUrl: string, lang: string, creationUserType: number) => {
        this.userName = name;
        this.creationUserType = creationUserType;
        this.urlLanguage = langUrl;
        this.language = lang;
        this.uid = this.uid;
    };

    GetNameUser = (): string => {
        return this.userName;
    };

    GetLanguage = (): string => {
        return this.language;
    }

    GetLanguageURL = (): string => {
        return this.urlLanguage;
    };

    GetUID = (): string => {
        return this.uid;
    };
    GetCreationUserType = (): number => {
        return this.creationUserType;
    };
}
